import { createFileRoute } from "@tanstack/react-router";
import IncidentProcedurePage from "@/pages/security/IncidentProcedurePage";

export const Route = createFileRoute("/security/incident-procedure")({
  component: IncidentProcedurePage,
});
